import { render, staticRenderFns } from "./FormTitleText.vue?vue&type=template&id=6f71c240&scoped=true&"
import script from "./FormTitleText.vue?vue&type=script&lang=js&"
export * from "./FormTitleText.vue?vue&type=script&lang=js&"
import style0 from "./FormTitleText.vue?vue&type=style&index=0&id=6f71c240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f71c240",
  null
  
)

export default component.exports